<template>
  <router-view></router-view>
</template>

<script>
export default {};
</script>

<style></style>



// WEBPACK FOOTER //
// Main.vue?073969b3